import {EntityBase} from "../../../shared/entity/EntityBase";

const PASS_MASTER_TABLE_FIELDS = {
    index: { type: Number, defaultValue: 0 },
    passType: { type: Number, defaultValue: 0 }, // 1: 월간, 2: 주간
    name: { defaultValue: '' },
}

export class PassMasterTableEntity extends EntityBase {
    constructor(data = {}) {
        super(data, PASS_MASTER_TABLE_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
            {condition: () => this.passType === 0, message: '패스 타입이 없습니다.'},
        ];
    }
}